<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Cód. Grupo', 'Grupo Econômico', 'Conta corrente', 'PA']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.codigoGrupoEconomico ? obj.codigoGrupoEconomico.toString() : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.descricaoGrupoEconomico" />
        <TableColumn :IsText="true" :status="1" :value="obj.contaCorrente" />
        <TableColumn :IsText="true" :status="1" :value="obj.pa ? obj.pa.descricao : ''" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import EconomicGroupRepository from '@/shared/http/repositories/business/economicgroup.js'
export default {
  name: 'EconomicGroup',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadEconomicGroup(this.document)
      }
    },
    onLoadEconomicGroup (document) {
      loading.push()
      this.document = document
      EconomicGroupRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/economicgroup.vue